import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import React from 'react'
import { useLocation } from 'react-router'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'
import LoyaltyLandingPageBenefitsTableSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageBenefitsTableSection'
import LoyaltyLandingPageHowItWorksSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageHowItWorksSection'
import LoyaltyAccountBenefitsProgressContent from './LoyaltyAccountBenefitsProgressContent'
import LoyaltyLandingPageMovingTiersSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageMovingTiersSection'
import LoyaltyLandingPageFaqSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageFaqSection'
import LoyaltyAccountLandingPageHero from './LoyaltyAccountLandingPageHero'
import LoyaltyLandingPageUSPSection from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageUSPSection'
import LoyaltyUserBronzeBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserBronzeBenefits'
import LoyaltyUserGoldBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserGoldBenefits'
import LoyaltyUserPlatinumBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserPlatinumBenefits'
import LoyaltyUserSilverBenefits from '../loyaltyLandingPageSharedSections/LoyaltyUserSilverBenefits'
import ToggleButton from 'components/Luxkit/ToggleButton'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import { useInView } from 'react-intersection-observer'

const NavSection = styled(Pane)`
  position: sticky;
  z-index: ${zIndex.stickyHeader};
  top: 0;
  padding: ${rem(12)} 0;
`

function LoyaltyAccountLandingPage() {
  const hash = useLocation().hash.replace('#', '')
  const activeTab = hash || 'about'
  const [tier] = useCurrentLoyaltyTier()
  const [stickyRef, notSticky] = useInView()
  return <div>
    <LoyaltyAccountLandingPageHero />
    <NavSection shadow={!notSticky}>
      <LayoutContainer variant="medium">
        <Group direction="horizontal" horizontalAlign="center" gap={8}>
          <ToggleButton
            orientation="horizontal"
            kind="primary"
            isSelected={activeTab === 'about'}
            href="#about"
            title="About Société"
          />
          <ToggleButton
            orientation="horizontal"
            kind="primary"
            isSelected={activeTab === 'benefits'}
            href="#benefits"
            title="Your benefits & progress"
          />
        </Group>
      </LayoutContainer>
    </NavSection>
    <div ref={stickyRef} />
    <Pane type="light-grey">
      {activeTab === 'about' && <LoyaltyLandingPageUSPSection />}
      <LayoutContainer variant="medium">
        {activeTab === 'about' && <>
          {tier === 'bronze' && <LoyaltyUserBronzeBenefits />}
          {tier === 'silver' && <LoyaltyUserSilverBenefits />}
          {tier === 'gold' && <LoyaltyUserGoldBenefits />}
          {tier === 'platinum' && <LoyaltyUserPlatinumBenefits /> }
        </>}
        {activeTab === 'benefits' && <LoyaltyAccountBenefitsProgressContent />}
      </LayoutContainer>
    </Pane>
    <LoyaltyLandingPageMovingTiersSection />
    <LoyaltyLandingPageBenefitsTableSection
      highlightTier={tier}
    />
    <LoyaltyLandingPageHowItWorksSection />
    <LoyaltyLandingPageFaqSection slug="societe-faqs-member" />
  </div>
}

export default LoyaltyAccountLandingPage
